export const FileTypes_Generic = `<svg title="FileTypes_Generic" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<path d="M3 3C3 1.34315 4.34315 0 6 0H15L21 6V21C21 22.6569 19.6569 24 18 24H6C4.34315 24 3 22.6569 3 21V3Z" fill="#EEDAF7"/>
<path d="M6 13H15V14.5H6V13Z" fill="#8944AB"/>
<path d="M6 16H18V17.5H6V16Z" fill="#8944AB"/>
<path d="M6 10H18V11.5H6V10Z" fill="#8944AB"/>
<path opacity="0.4" d="M15 0L21 6H17C15.8954 6 15 5.10457 15 4V0Z" fill="#8944AB"/>
</svg>`;